<template>
  <div class="content">
    <div class="box">
      <p>多国签证</p>
<!--      <p>Multinational visa</p>-->
      <div class="bottom-box">
        <div>
          <a-input-search
            placeholder="请输入国家名称"

            @search="(e) => {
              search(e)
            }" >
            <a-button slot="enterButton" @mouseover="turnColor" @mouseout="resetColor">
              <img v-if="searchState" src="../../../assets/images/goaboard/icon_visa_countries_search.svg">
              <img v-else src="../../../assets/images/goaboard/icon_visa_countries_search_hover.svg">
            </a-button>
          </a-input-search>
        </div>
        <div>
          <img src="../../../assets/images/icon_visa_countries_tel.png">
          0591-87856791
        </div>
        <div>
          <img src="../../../assets/images/icon_visa_countries_mail.png">
          604944320@qq.com
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multinational-visa',
  methods: {
    search (e) {
      this.$emit('set-search', e)
    },
    turnColor () {
      this.searchState = false
    },
    resetColor () {
      this.searchState = true
    }
  },
  data() {
    return {
      searchState: true
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  height: 260px;
  margin-top: 40px;
  margin-bottom: 47px;
}
.box {
  width: 1140px;
  height: 260px;
  position: relative;
  margin: auto;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(203, 180, 134, 1);
  p {
    font-size: 36px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin: 55px 0;
  }
  //p:first-of-type {
  //  font-size: 36px;
  //  font-family: Microsoft YaHei;
  //  font-weight: bold;
  //  color: #FFFFFF;
  //  margin-top: 45px;
  //  height: 36px;
  //}
  //p:last-of-type {
  //  font-size: 16px;
  //  font-family: Microsoft YaHei;
  //  font-weight: 400;
  //  color: #FAF5F5;
  //  height: 33px;
  //  margin-top: 12px;
  //}
}
.bottom-box {
  height: 40px;
  margin-top: 30px;
  text-align: left;
  div {
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    img {
      vertical-align: top;
    }
  }
  div:nth-of-type(1) {
    width: 400px;
    margin-left: 127px;
  }
  div:nth-of-type(2) {
    margin-left: 94px;
  }
  div:nth-of-type(3) {
    margin-left: 22px;
  }
}
/deep/ .ant-input{
  height: 40px;
  border-color: white;
}
/deep/ .ant-btn {
  width: 55px;
  height: 39px;
  border: none;
  //border-left: 1px solid rgba(153, 155, 163, 1);
  border-left: 1px solid #e5e5e5;
  box-shadow: none;
}
/deep/ .ant-btn:focus {
  border-left: 1px solid #e5e5e5;
}
/deep/ .ant-btn:hover {
  border-left: 1px solid #e5e5e5;
}
/deep/ .ant-btn-primary {
  background-color: #FFF;
  border-color: #FFF;
  border: none;
  color: rgba(153, 155, 163, 1);
  border-left: 1px solid rgba(153, 155, 163, 0.5);
  font-size: 20px;
  box-shadow: none;
}
/deep/ .ant-input-group {
  line-height: 36px;
}
/deep/ .ant-input:hover {
  border-color: #FFF;
}
/deep/ .ant-input:focus {
  border-color: #FFF;
  box-shadow: none;
}
/deep/ .ant-input-search-button {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/siderContent-04.vue